import { useState } from 'react'

/**
 * Custom hook for managing dialog/modal state
 * Provides open, close, and toggle functionality
 * 
 * @param {boolean} initialState - Initial open state (default: false)
 * @returns {Object} Dialog state and handlers
 */
export function useDialog(initialState = false, initialData = null) {
    const [isOpen, setIsOpen] = useState(initialState)
    const [data, setData] = useState(initialData)

    const open = (modalData) => {
        if (modalData !== undefined) setData(modalData)
        setIsOpen(true)
    }

    const close = () => {
        setIsOpen(false)
        setData(null)
    }

    const toggle = () => setIsOpen(prev => !prev)

    return {
        isOpen,
        data,
        open,
        close,
        openDialog: open,
        closeDialog: close,
        toggle,
        setIsOpen,
        setData
    }
}
